import { SourcingEventDto } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { mayCreateContractFromEvent } from "../../../common/departments/eventCreationDepartments";

export const useMayCreateContract = (event: SourcingEventDto): boolean => {
  const { selectedOrg } = useLoggedInWithOrgContextState();
  return mayCreateContractFromEvent(selectedOrg, event.homeDepartment?.id);
};
